import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiClient from '../utils/api';
import './SubscriptionSuccess.css';

function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState('');

  useEffect(() => {
    // PayPal returns ba_token for subscriptions, subscription_id, or token
    const baToken = searchParams.get('ba_token');
    const subscriptionId = searchParams.get('subscription_id');
    const token = searchParams.get('token');
    const sessionId = searchParams.get('session_id');
    
    const identifier = baToken || subscriptionId || token || sessionId;
    
    if (!identifier) {
      setStatus('error');
      setError('Keine Zahlungs-ID gefunden');
      return;
    }

    console.log('Payment identifier found:', identifier);
    
    // For PayPal subscriptions, we assume success if we have ba_token
    if (baToken || subscriptionId) {
      // PayPal subscription - check subscription status
      checkSubscriptionStatus(identifier);
    } else {
      // Regular payment - poll status
      pollPaymentStatus(identifier);
    }
  }, [searchParams]);

  const checkSubscriptionStatus = async (token) => {
    try {
      console.log('🔵 Activating subscription with token:', token);
      
      // Call backend to activate subscription after PayPal approval
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscriptions/activate?subscription_id=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const subscription = await response.json();
        console.log('✅ Subscription activated:', subscription);
        setStatus('success');
      } else {
        const error = await response.json();
        console.error('❌ Activation failed:', error);
        setStatus('error');
        setError(error.detail || 'Subscription konnte nicht aktiviert werden');
      }
    } catch (error) {
      console.error('❌ Error activating subscription:', error);
      setStatus('error');
      setError('Fehler bei der Aktivierung. Bitte kontaktiere den Support.');
    }
  };

  const pollPaymentStatus = async (sessionId, attempts = 0) => {
    const maxAttempts = 5;

    if (attempts >= maxAttempts) {
      setStatus('timeout');
      return;
    }

    try {
      const result = await apiClient.getCheckoutStatus(sessionId);

      if (result.payment_status === 'paid') {
        setStatus('success');
        return;
      } else if (result.status === 'expired') {
        setStatus('expired');
        return;
      }

      // Continue polling
      setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), 2000);
    } catch (error) {
      console.error('Error checking status:', error);
      setStatus('error');
      setError(error.message);
    }
  };

  return (
    <div className="subscription-result-page">
      <div className="result-container">
        {status === 'checking' && (
          <>
            <div className="result-spinner"></div>
            <h1>Zahlung wird überprüft...</h1>
            <p>Bitte warten Sie einen Moment</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="result-icon success">✅</div>
            <h1>Willkommen bei ZENTA!</h1>
            <p>Deine Zahlung war erfolgreich. Dein Abo ist jetzt aktiv.</p>
            <button onClick={() => navigate('/dashboard')} className="btn-continue">
              Zum Dashboard
            </button>
          </>
        )}

        {(status === 'error' || status === 'timeout' || status === 'expired') && (
          <>
            <div className="result-icon error">❌</div>
            <h1>Zahlung fehlgeschlagen</h1>
            <p>{error || 'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.'}</p>
            <div className="result-actions">
              <button onClick={() => navigate('/pricing')} className="btn-retry">
                Erneut versuchen
              </button>
              <button onClick={() => navigate('/dashboard')} className="btn-back">
                Zurück zum Dashboard
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
